module.exports = __webpack_public_path__ + "img/icon-del-red.6a17213e.svg";